import React, { Component } from 'react';
import { Modal, Select, message, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { Option } = Select;

class UpdateChargeHospital extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
        hospitalList: [],
        courtyardList: [],
        departmentList: [],
        courtyardDisabled: false,
    }

    show = (parentRecord, record) => {
        const { userId, userCompellation, employeeCode } = parentRecord;
        const params = {
            userId,
            userCompellation,
            employeeCode,
            isEdit: !!record,
        };
        //编辑回显 先用行上带的名称 初始化三个下拉 保证 医院/院区/科室 显示名称而不是id
        let hospitalList = [];
        let courtyardList = [];
        let departmentList = [];
        //仅一条且院区信息为空 时 院区不可编辑
        let courtyardDisabled = false;
        if (record) {
            params.userResponsibleHospitalId = record.userResponsibleHospitalId;
            params.hospitalMainId = record.hospitalMainId;
            params.hospitalMainLabel = record.hospitalName;
            params.hospitalId = record.hospitalId;
            params.hospitalDepartmentId = record.hospitalDepartmentId;
            params.yesNo = record.yesNo;
            if (record.hospitalMainId) {
                hospitalList = [{ hospitalMainId: record.hospitalMainId, hospitalName: record.hospitalName }];
            }
            if (record.hospitalId) {
                courtyardList = [{ hospitalId: record.hospitalId, courtyardArea: record.courtyardArea, hospitalName: record.hospitalName }];
                courtyardDisabled = !record.courtyardArea;
            }
            if (record.hospitalDepartmentId) {
                departmentList = [{ hospitalDepartmentId: record.hospitalDepartmentId, departmentLocalName: record.hospitalDepartmentName }];
            }
        }
        this.setState({
            params,
            hospitalList,
            courtyardList,
            departmentList,
            courtyardDisabled,
            visible: true,
        }, () => {
            //异步加载完整下拉列表
            if (params.hospitalMainId) {
                this.loadCourtyardList(params.hospitalMainId, params.hospitalId, params.hospitalDepartmentId);
            } else {
                this.loadHospitalList('');
            }
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    loadHospitalList = (keyword, mainId) => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryChargeHospitalMainList,
            data: {
                keyword: keyword || '',
                mainId: mainId || '',
            },
            dataType: 'json',
            doneResult: res => {
                //搜索结果直接展示 不再拼入已选中的主医院 已选名称由 labelInValue 保持显示
                this.setState({
                    hospitalList: res.list || [],
                });
            },
        };
        $.sendRequest(options);
    }

    loadCourtyardList = (hospitalMainId, keepHospitalId, keepDepartmentId) => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryChargeCourtyardList,
            data: {
                hospitalMainId,
            },
            dataType: 'json',
            doneResult: res => {
                let list = res.list || [];
                //已选中的院区不在列表中时 保留已选项 避免显示id
                const { params, courtyardList } = this.state;
                if (keepHospitalId && params.hospitalId && !list.some(i => i.hospitalId == params.hospitalId)) {
                    const selected = (courtyardList || []).find(i => i.hospitalId == params.hospitalId);
                    if (selected) {
                        list = [selected, ...list];
                    }
                }
                //仅一条 且 院区信息为空 时 院区不可编辑 自动选中该条 查询科室和提交的 hospitalId 都取该条的医院ID
                let courtyardDisabled = false;
                if (list.length === 1 && (!list[0].courtyardArea || list[0].courtyardArea == '')) {
                    courtyardDisabled = true;
                    params.hospitalId = list[0].hospitalId;
                }
                this.setState({
                    courtyardList: list,
                    courtyardDisabled,
                    params,
                }, () => {
                    if (courtyardDisabled) {
                        //院区已自动选中 直接按该院区行加载科室
                        this.loadDepartmentList(params.hospitalId, keepDepartmentId);
                    } else if (!keepHospitalId) {
                        this.clearHospitalId();
                    } else if (keepDepartmentId) {
                        //编辑回显 继续加载科室下拉
                        this.loadDepartmentList(params.hospitalId, keepDepartmentId);
                    }
                });
            },
        };
        $.sendRequest(options);
    }

    loadDepartmentList = (hospitalId, keepDepartmentId) => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryChargeDepartmentList,
            data: {
                hospitalId,
            },
            dataType: 'json',
            doneResult: res => {
                let list = res.list || [];
                //已选中的科室不在列表中时 保留已选项 避免显示id
                const { params, departmentList } = this.state;
                if (keepDepartmentId && params.hospitalDepartmentId && !list.some(i => i.hospitalDepartmentId == params.hospitalDepartmentId)) {
                    const selected = (departmentList || []).find(i => i.hospitalDepartmentId == params.hospitalDepartmentId);
                    if (selected) {
                        list = [selected, ...list];
                    }
                }
                this.setState({
                    departmentList: list,
                }, () => {
                    if (!keepDepartmentId) {
                        this.clearDepartmentId();
                    }
                });
            },
        };
        $.sendRequest(options);
    }

    clearHospitalId = () => {
        const { params } = this.state;
        params.hospitalId = undefined;
        params.hospitalDepartmentId = undefined;
        this.setState({ params, departmentList: [] });
    }

    clearDepartmentId = () => {
        const { params } = this.state;
        params.hospitalDepartmentId = undefined;
        this.setState({ params });
    }

    submit = () => {
        const {
            params: {
                userId,
                userResponsibleHospitalId,
                hospitalMainId,
                hospitalId,
                hospitalDepartmentId,
                yesNo,
                isEdit,
            },
        } = this.state;
        if (!hospitalMainId) {
            message.warning('请选择负责医院');
            return;
        }
        if (!hospitalId) {
            message.warning('请选择负责院区');
            return;
        }
        if (!hospitalDepartmentId) {
            message.warning('请选择负责科室');
            return;
        }
        if (yesNo === undefined || yesNo === null || yesNo === '') {
            message.warning('请选择是否主要负责医院科室');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: isEdit ? API_URL.user.updateUserChargeHospital : API_URL.user.addUserChargeHospital,
            data: isEdit ? {
                userResponsibleHospitalId,
                hospitalMainId,
                hospitalId,
                hospitalDepartmentId,
                yesNo,
            } : {
                userId,
                hospitalMainId,
                hospitalId,
                hospitalDepartmentId,
                yesNo,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData(userId);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleMainHospitalChange = (value) => {
        const { params } = this.state;
        //labelInValue 选中的值为 {key, label}
        params.hospitalMainId = value.key;
        params.hospitalMainLabel = value.label;
        this.setState({ params }, () => {
            this.loadCourtyardList(value.key);
        });
    }

    handleCourtyardChange = (value) => {
        const { params } = this.state;
        params.hospitalId = value;
        this.setState({ params }, () => {
            this.loadDepartmentList(value);
        });
    }

    handleDepartmentChange = (value) => {
        const { params } = this.state;
        params.hospitalDepartmentId = value;
        this.setState({ params });
    }

    handleYesNoChange = (value) => {
        const { params } = this.state;
        params.yesNo = value;
        this.setState({ params });
    }

    handleHospitalSearch = (keyword) => {
        this.loadHospitalList(keyword);
    }

    getContent = () => {
        const {
            params: {
                userCompellation,
                employeeCode,
                hospitalMainId,
                hospitalMainLabel,
                hospitalId,
                hospitalDepartmentId,
                yesNo,
            },
            hospitalList,
            courtyardList,
            departmentList,
            courtyardDisabled,
        } = this.state;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        //统一 标签列/控件列 宽度 使 冒号右对齐 选择框左对齐
        const leftStyle = { width: '40%' };
        const rightStyle = { width: '60%' };
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left" style={leftStyle}>人员:</div>
                    <div className="item-right" style={rightStyle}>
                        {`${userCompellation}[${employeeCode}]`}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={leftStyle}>{asterisk}负责医院:</div>
                    <div className="item-right" style={rightStyle}>
                        <Select
                            showSearch
                            labelInValue
                            style={{ width: 182 }}
                            value={hospitalMainId ? { key: hospitalMainId, label: hospitalMainLabel } : undefined}
                            placeholder="请输入名称检索"
                            defaultActiveFirstOption={false}
                            filterOption={false}
                            onSearch={this.handleHospitalSearch}
                            onChange={this.handleMainHospitalChange}
                            notFoundContent="无匹配数据"
                        >
                            {hospitalList.map(item => (
                                <Option key={item.hospitalMainId} value={item.hospitalMainId}>{item.hospitalName}</Option>
                            ))}
                        </Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={leftStyle}>{asterisk}负责院区:</div>
                    <div className="item-right" style={rightStyle}>
                        <Select
                            style={{ width: 182 }}
                            value={hospitalId}
                            placeholder="请选择"
                            disabled={courtyardDisabled}
                            onChange={this.handleCourtyardChange}
                        >
                            {courtyardList.map(item => (
                                <Option key={item.hospitalId} value={item.hospitalId}>
                                    {courtyardDisabled ? ' ' : (item.courtyardArea || item.hospitalName)}
                                </Option>
                            ))}
                        </Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={leftStyle}>{asterisk}负责科室:</div>
                    <div className="item-right" style={rightStyle}>
                        <Select
                            style={{ width: 182 }}
                            value={hospitalDepartmentId}
                            placeholder="请选择"
                            onChange={this.handleDepartmentChange}
                        >
                            {departmentList.map(item => (
                                <Option key={item.hospitalDepartmentId} value={item.hospitalDepartmentId}>{item.departmentLocalName}</Option>
                            ))}
                        </Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={leftStyle}>{asterisk}是否主要负责医院科室:</div>
                    <div className="item-right" style={rightStyle}>
                        <Select
                            style={{ width: 182 }}
                            value={yesNo === undefined || yesNo === null ? undefined : yesNo}
                            placeholder="请选择"
                            onChange={this.handleYesNoChange}
                        >
                            <Option value={1}>是</Option>
                            <Option value={0}>否</Option>
                        </Select>
                    </div>
                </li>
            </ul>
        )
    }

    render() {
        const { visible, loading } = this.state;
        const { params: { isEdit } } = this.state;
        return (
            <Modal
                title={`${isEdit ? '修改' : '添加'}负责医院科室`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="setjde-modal addchildcontract"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="520px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateChargeHospital;



// WEBPACK FOOTER //
// ./src/components/user/userInfo/UpdateChargeHospital.js